// extracted by mini-css-extract-plugin
export default {"section":"r2idK","align--center":"MKuzF","align--left":"gRRaL","align--right":"nC1ag"};